import React from "react";
import { parseISO } from "date-fns";
import type { ExpiryItem } from "../hooks/useExpiryItems";
import { getDateColorClass, formatDisplayDate } from "../utils/expiryUtils";

interface ExpiryDateCellProps {
  /** Raw ISO date string value from the table row, or null/undefined if missing. */
  value: string | null | undefined;
  /** Full row object — required to derive the correct colour class. */
  item: ExpiryItem;
}

/**
 * Renders the "Expiry Date" column cell: formatted date text coloured by urgency.
 * Returns "—" when no expiry date is set.
 */
const ExpiryDateCell: React.FC<ExpiryDateCellProps> = ({ value, item }) => (
  <span className={getDateColorClass(item)}>
    {value ? formatDisplayDate(value) : "—"}
  </span>
);

export default ExpiryDateCell;
